import PlainActionsButton, { type PlainActionsButtonProps } from './plain-actions-button'


export type { PlainActionsButtonProps }
export default PlainActionsButton
